<template>
  <!-- dynamically load report -->
  <v-row class="justify-center font-weight-thin">
    <v-col class="col-12 hide-on-print px-8">
      <!-- top navigation -->
      <top-navigation
        :route-object="{ name: 'reports', params: { date } }"
        :title="report.getTitle()"
        icon-title="fa-book-open"
        :button-min-width="160"
      />

      <!-- print button -->
      <v-col class="col-6">
        <v-btn
          color="green"
          class="white--text"
          large
          :min-width="160"
          @click="print()"
        >
          <span class="fal fa-print fa-2x mr-2" />
          {{ $t('general.print') }}
        </v-btn>
      </v-col>
    </v-col>

    <v-col
      ref="page"
      :class="[report.getOrientation() === 'landscape' ? 'A4-landscape' : 'A4']"
      class="py-0"
    >
      <component
        :is="report.getTemplate()"
        class="ma-4 row"
        :date="date"
        :report="report"
      />
    </v-col>
  </v-row>
</template>

<script>
import TopNavigation from '../../../components-shared/menus/TopNavigation'
export default {
  name: 'SingleReport',

  components: {
    TopNavigation,
    ReportNiesenGroups: () => import('./niesen/ReportNiesenGroups.vue'),
    ReportNiesenHotel: () => import('./niesen/ReportNiesenHotel.vue'),
    ReportNiesenLunch: () => import('./niesen/ReportNiesenLunch'),
    ReportNiesenOverview: () => import('./niesen/ReportNiesenOverview'),
    ReportNiesenMorningEvening: () =>
      import('./niesen/ReportNiesenMorningEvening'),
  },

  data() {
    return {
      // report instance (passed by router)
      report: null,

      // selected date
      date: null,
    }
  },

  beforeMount() {
    // get data passed by router
    this.report = this.$route.params.report
    this.date = this.$route.params.date
  },

  mounted() {
    this.setPageSize(this.report.getOrientation())
  },

  beforeDestroy() {
    this.setPageSize('portrait')
  },

  methods: {
    print() {
      window.print()
    },

    setPageSize(cssPageSize) {
      const style = document.createElement('style')
      style.innerHTML = `@page {size: ${cssPageSize}}`
      document.head.appendChild(style)
    },
  },
}
</script>
